export interface ErrorCardProps {
  type: ErrorsType;
  className?: string;
  onActionClick?: () => void;
  customCtaComponent?: React.ReactNode;
  imageUrl?: string;
  buttonLabel?: string;
  title?: string;
  description?: string;
  customImageClass?: string;
  restrictedButton?: React.ReactNode;
}

type ErrorsType = keyof typeof Errors;
export enum Errors {
  NotFound = 'NotFound',
  Restricted = 'Restricted',
  General = 'General',
  Maintenance = 'Maintenance',
}

export { ErrorsType };
